<template>
    <v-card width="100%" style="border-radius: 12px; overflow: hidden">
        <v-form @submit.prevent="sendEmail" ref="form">
            <v-card-item>
                <v-card-title>
                    <b>{{ formData && formData.name ? formData.name : '' }}</b>
                    <v-btn @click="setFalse()" elevation="0" density="comfortable" icon="mdi-close"
                        class="x-closeIcon"></v-btn>
                </v-card-title>
            </v-card-item>

            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="12" class="mt-4"
                        v-if="formData.name && formData.name.toLowerCase() != 'timesheetexception'">
                        <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Work Space
                            <span style="color: #cf0707; padding-left: 2px; font-weight: 700"></span></v-label>
                        <!-- <AutoComplete :items="wsData" item-value="id" item-title="name" density="compact"
                            placeholder="Select Work Space" @update:modelValue="getAccountData"
                            v-model="formData.work_space_id" v-model:search="searchText" :disabled="showReadOnly"
                            multiple /> -->

                        <AutoComplete :items="wsData" item-value="id" item-title="name" density="compact"
                            placeholder="Select Work Space" @update:modelValue="getAccountData"
                            v-model="formData.work_space_id" :disabled="showReadOnly" multiple />

                    </v-col>
                    <v-col cols="12" v-if="wsError" class="mt-4">
                        <v-error>Work Space is Required.</v-error>
                    </v-col>
                    <v-col cols="12" class="mt-4"
                        v-if="formData.name && formData.name.toLowerCase() != 'timesheetexception' && formData.name.toLowerCase() != 'issuetimesheet'">
                        <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Account
                            <span style="color: #cf0707; padding-left: 2px; font-weight: 700"></span></v-label>
                        <AutoComplete :items="accountData" item-value="id" item-title="name" density="compact"
                            placeholder="Account" v-model="formData.account_id" v-model:search="searchText"
                            :disabled="showReadOnly" multiple />
                    </v-col>
                    <v-col cols="12" v-if="accountError" class="mt-4">
                        <v-error>Account is Required.</v-error>
                    </v-col>
                    <v-col cols="12" class="mt-4"
                        v-if="formData.name && (formData.name.toLowerCase() == 'timesheetexception' || formData.name.toLowerCase() == 'issuetimesheet')">
                        <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Entry Date
                            <span style="color: #cf0707; padding-left: 2px; font-weight: 700"></span></v-label>
                        <DatePicker style="padding-bottom: 0px !important;" @update:modelValue="getExceptionData"
                            :data="formData.entry_date" :selectionMode="'range'" :placeholder="'Entry Date'"
                            @selectDate="selectDate($event)" />
                    </v-col>
                    <v-col cols="12" v-if="entryDateError" class="mt-4">
                        <v-error>Entry Date is Required.</v-error>
                    </v-col>
                    <v-col cols="12" class="mt-4">
                        <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">Email
                            <span
                                style="color: green; padding-left: 2px;">(Example:abc@coreforce.com,123@gmail.com)</span></v-label>
                        <TextFieldComponent density="compact" placeholder="Email" @click="changeEmail"
                            @mouseover="changeEmail" @input="changeEmail" :rules="emailRule" v-model="formData.email"
                            :disabled="showReadOnly" />
                    </v-col>
                    <v-col cols="12" class="mt-4">
                        <v-label class="pb-1" style="font-size: 14px; color: #272727; font-weight: 600">CC
                            <span
                                style="color: green; padding-left: 2px;">(Example:abc@coreforce.com,123@gmail.com)</span></v-label>
                        <TextFieldComponent density="compact" placeholder="CC" :rules="nameRule" v-model="formData.cc"
                            :disabled="showReadOnly" />
                    </v-col>

                    <v-col cols="12">
                        <span></span>
                    </v-col>

                </v-row>
            </v-card-text>
            <v-card-action class="mr-3">
                <v-row justify="end" class="dialogBottom" v-if="!showReadOnly">
                    <v-btn class="mr-2 cancel" @click="dialog = setFalse()">Cancel</v-btn>
                    <v-btn class="save" :loading="saveClicked" type="submit">Send Email</v-btn>
                </v-row>
            </v-card-action>
        </v-form>
    </v-card>
</template>


<script>
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import AutoComplete from "@/components/ui/AutoComplete.vue";
import ListModelService from "@/api/service/ListModel/ListModelService";
import ReportService from "@/api/service/Report/ReportService";
import commonService from "@/common.service";
import DatePicker from "@/components/ui/DatePicker.vue";
import AccountService from "@/api/service/Account/AccountService";
import WorkSpaceService from "@/api/service/WorkSpace/WorkSpaceService";
export default {
    props: ['id'],
    components: {
        AutoComplete,
        DatePicker,
        TextFieldComponent
    },
    data() {
        return {
            wsData: [],
            searchText: null,
            accountData: [],
            emailRule: [(value) => !!value || "Email is Required."],
            saveClicked: false,
            formData: {},
            listModelData: null,
            accountError: false,
            entryDateError: false,
            wsError: false,
            email: null,
            // selectAllIndicator:false

        }
    },
    watch: {
        id() {
            if (this.id) {
                this.formData = {};
                this.getReportData(this.id);
            }
        }
    },
    created() {
        if (this.id) {
            this.getReportData(this.id)
        }
        this.getWsData()
        // this.getAccountData() 
    },

    methods: {
        async getWsData() {
            try {
                let res = await WorkSpaceService.getWorkSpaceByUser();
                if (res && res.length > 0) {
                    this.wsData = [{ id: 0, name: "Select All" }, ...res]
                    console.log(this.wsData, "this.wsDatathis.wsData");
                } else {
                    this.wsData = [];
                }

            } catch (exception) {
                this.wsData = [];
                console.log(exception, 'error');
            }
        },

        async changeEmail() {
            if (this.formData && this.formData.email && this.email && this.formData.email.length <= this.email.length) {
                this.formData.email = this.email
            }
        },
        async getReportData(id) {
            try {
                let res = await ListModelService.findAll({ id: id, active: 1 })
                this.formData = res && res.length > 0 ? res[0] : {}
                let userData = localStorage.getItem('user_details')
                console.log(userData, "user datata")
                userData = userData ? JSON.parse(userData) : null
                this.email = userData && userData.email ? userData.email : null
                this.formData.email = this.email
            }
            catch (e) {
                console.log(e)
            }
        },
        selectDate($event) {
            this.entryDateError = false
            this.formData.entry_date = $event;
        },

        // async getAccountData(val) {

        //   console.log("### selected:", val);

        //   this.searchText = null;
        //   this.accountData = [];

        //   try {
        //     if (!Array.isArray(this.formData.work_space_id)) {
        //       this.formData.work_space_id = [];
        //     }

        //     let workspaceIds = [];


        //     if (val && val.length > 0) {

        //       if (val.includes(0)) {
        //         if (val.length === 1) { 

        //           this.selectAllIndicator = true;
        //           workspaceIds = this.wsData.map(item => item.id);
        //         } else if (val.length === this.wsData.length) {
        //           this.selectAllIndicator = false;
        //           workspaceIds = this.wsData.map(item => item.id);
        //         }
        //          else {
        //           this.selectAllIndicator = false;
        //           workspaceIds = val.filter(id => id !== 0);
        //         }
        //       } else {

        //         if(this.selectAllIndicator){
        //              workspaceIds = [];
        //         }else{
        //             workspaceIds = [...val];
        //         }

        //       }
        //     } else {
        //       workspaceIds = [];
        //     }


        //     this.formData.work_space_id = [];
        //     this.$nextTick(() => {
        //       this.formData.work_space_id = [...workspaceIds];
        //     });

        //     const wsIds = workspaceIds.filter(id => id !== 0);

        //     if (wsIds.length > 0) {
        //       const res = await AccountService.getAccountByUser({
        //         work_space_id: wsIds.join(','),
        //       });

        //       this.accountData =
        //         res && res.length > 0
        //           ? await commonService.getSort(res, "name", "asc")
        //           : [];
        //       this.accountData = this.accountData.filter(a => a.active == 1);
        //     } else {
        //       this.accountData = [];
        //     }
        //   } catch (e) {
        //     console.log(e);
        //   }
        // },

        async getAccountData(val) {
            //   console.log("### selected:", val);
            this.searchText = null;
            this.accountData = [];
            this.wsError = false
            try {
                if (!Array.isArray(this.formData.work_space_id)) {
                    this.formData.work_space_id = [];
                }

                let workspaceIds = [];

                if (val && val.length > 0) {
                    if (val.includes(0)) {
                        workspaceIds = this.wsData.map(item => item.id);
                    } else {
                        if (this.formData.work_space_id.includes(0)) {
                            workspaceIds = [];
                        } else {
                            workspaceIds = [...val];
                        }
                    }
                } else {
                    workspaceIds = [];
                }

                this.formData.work_space_id = [];
                this.$nextTick(() => {
                    this.formData.work_space_id = [...workspaceIds];
                });

                const wsIds = workspaceIds.filter(id => id !== 0);

                if (wsIds.length > 0) {
                    const res = await AccountService.getAccountByUser({
                        work_space_id: wsIds.join(','),
                    });

                    this.accountData =
                        res && res.length > 0
                            ? await commonService.getSort(res, "name", "asc")
                            : [];
                    this.accountData = this.accountData.filter(a => a.active == 1);
                } else {
                    this.accountData = [];
                }
            } catch (e) {
                console.log(e);
            }
        },
        setFalse() {
            this.$emit("closeDialog");
        },
        async sendEmail() {
            let validation = await this.$refs.form.validate()
            let $validRequired = false
            if ((this.formData.name.toLowerCase() != 'timesheetexception') && (!validation.valid || !this.formData || !this.formData.work_space_id || this.formData.work_space_id.length == 0)) {
                // this.accountError = true
                $validRequired = true
                this.wsError = !this.formData.work_space_id || this.formData.work_space_id.length == 0 ? true : false
            }
            if ((this.formData.name.toLowerCase() == 'timesheetexception' || this.formData.name.toLowerCase() == 'issuetimesheet') && (!validation.valid || !this.formData || !this.formData.entry_date || this.formData.entry_date.length == 0)) {
                $validRequired = true
                this.entryDateError = this.formData.entry_date && this.formData.entry_date.length > 0 ? false : true
            }
            if ($validRequired) {
                console.log('fail')
            }
            else {
                try {
                    let res = await ReportService.sendReport(this.formData)
                    console.log(res)
                    this.setFalse()
                    this.$store.dispatch("setSnackbar", { text: "Email Sent Successfully" });
                }
                catch (e) {
                    this.$store.dispatch("setSnackbar", {
                        color: "error",
                        text: "Something Went Wrong Email Not Send",
                    });
                    console.log(e);
                }
            }
        }
    }

}
</script>